import { LookupUser, useUserLookupStore } from 'use-towns-client'

export function lookupUserNameSearchString(user: LookupUser) {
    const memberOf = useUserLookupStore.getState().allUsers[user.userId]
    return Object.values(memberOf ?? {})
        .flatMap((info: LookupUser) => [info.displayName, info.username, info.ensName])
        .join(' ')
        .trim()
}
